import {Component, DestroyRef, OnInit, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SupportRequestEmail} from 'src/app/models/SupportInformation.model';
import {DataService} from 'src/app/services/data.service';
import {SalesService} from 'src/app/services/sales.service';
import {ValidateBirthdate, ValidateEmail} from '../validators/form-validator';
import {EventsManager} from '../../events/events.manager';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  standalone: false
})

export class SupportComponent implements OnInit {
  private _destroyRef: DestroyRef = inject(DestroyRef);
  public dataService: DataService = inject(DataService);
  private _salesService: SalesService = inject(SalesService);
  private _eventsManager: EventsManager = inject(EventsManager);
  public successMessage: boolean = false;
  public plans: any = {};
  private _currentDateValue: string = '';
  public supportRequestForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    dob: new FormControl('', [ValidateBirthdate]),
    emailAddress: new FormControl('', [ValidateEmail]),
    question: new FormControl(null),
    message: new FormControl('')
  });

  public ngOnInit(): void {
    this.plans = this._eventsManager.getOfficeInfo();
  }

  public sendSupportEmail(): void {
    const request: SupportRequestEmail = {
      FirstName: this.supportRequestForm.controls['firstName'].value,
      LastName: this.supportRequestForm.controls['lastName'].value,
      EmailAddress: this.supportRequestForm.controls['emailAddress'].value,
      DateOfBirth: this.supportRequestForm.controls['dob'].value,
      Question: this.supportRequestForm.controls['question'].value,
      Message: this.supportRequestForm.controls['message'].value,
      // PLANS-18301: send the same template the page resolves the displayed support
      // address from, so the email reaches the plan-specific support inbox.
      BenefitPlanTemplateId: this.plans?.benefitPlanTemplates?.[0]?.benefitPlanTemplateId
    };
    this._salesService.sendSupportEmail(request).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(()=>{
      this.successMessage = true;
    });
  }

  public setFeeScheduleInfo(plan: any) {
    const d = {practiceId: this.plans.practiceId, templateId: plan.benefitPlanTemplateId, pageName: 'FeeSchedule'};
    sessionStorage['fees'] = JSON.stringify(d);
    this._eventsManager.setFeeScheduleInfo(d);
  }

  public dateFormat(event: any) {
    if (this._currentDateValue.length < 10 && event.target.value.length <= 10 && event.key !== 'Backspace') {
      if (event.target.value.length == 2) {
        event.target.value += '/';
      } else if (event.target.value.length == 5) {
        event.target.value += '/';
      }
      this._currentDateValue = event.target.value;
    } else if (event.key === 'Backspace') {
      this._currentDateValue = event.target.value;
    } else {
      event.target.value = this._currentDateValue;
    }
  }
}
